export var HomeDashboardSubjects;
(function (HomeDashboardSubjects) {
    HomeDashboardSubjects["HomeDashboardPage"] = "home-dashboard-page";
    HomeDashboardSubjects["TableEmptyState"] = "table-empty-state";
    HomeDashboardSubjects["RecentEventsTable"] = "recent-events-table";
    HomeDashboardSubjects["EventRecordInvestigateButton"] = "event-record-investigate-button";
    HomeDashboardSubjects["EventRecordAiButton"] = "event-record-ai-button";
    HomeDashboardSubjects["LogsCounter"] = "logs-counter";
    HomeDashboardSubjects["MetricsCounter"] = "metrics-counter";
    HomeDashboardSubjects["TracesCounter"] = "traces-counter";
    HomeDashboardSubjects["AlertsCounter"] = "alerts-counter";
    HomeDashboardSubjects["InsightsCounter"] = "insights-counter";
    HomeDashboardSubjects["ExceptionsCounter"] = "exceptions-counter";
    HomeDashboardSubjects["HomeDashboardFavItem"] = "home-dashboard-fav-item";
    HomeDashboardSubjects["HomeDashboardFavorites"] = "home-dashboard-favorites";
    HomeDashboardSubjects["FavoritesSearchResults"] = "home-dashboard-fav-search-results";
    HomeDashboardSubjects["FavoritesBookmarks"] = "home-dashboard-fav-bookmarks";
    HomeDashboardSubjects["FavoritesRecent"] = "home-dashboard-fav-recent";
    HomeDashboardSubjects["FavoritesSuggestions"] = "home-dashboard-fav-suggestions";
})(HomeDashboardSubjects || (HomeDashboardSubjects = {}));
export var HomeDashboardEventType;
(function (HomeDashboardEventType) {
    HomeDashboardEventType["EXCEPTIONS"] = "Exceptions";
    HomeDashboardEventType["INSIGHTS"] = "Insights";
    HomeDashboardEventType["ALERTS"] = "Alerts";
})(HomeDashboardEventType || (HomeDashboardEventType = {}));
//# sourceMappingURL=home-dashboard.enum.js.map